<template>
  <!-- 
    @Author shirleywanghui@didichuxing.com
    @Date 2022-04-26
    @Description cgc推荐页改版 - 挽留弹窗 - 
  -->
  <div class="recommend_alert_dialog">
    <div class="layer"></div>
    <div class="dialog">
      
      <img :src="country === 'BR' ?
      require('../../../../assets/images/cgc/99/dialog_head_img.png') :
      require('../../../../assets/images/cgc/didi/dialog_head_img.png')"
      />
      <div class="background_container"></div>
      <div class="title">
        <span class="main">{{title}}</span>
      </div>
      <div class="footer_buttons">
        <div class="back button" @click="leaveImmediate">{{$t('FoodC_CGC_Cruel_departure_Smts' /**残忍离开*/)}}</div>
        <div class="stay button" @click="$emit('close')">{{$t('FoodC_CGC_Go_and_fnbj' /**去领取*/)}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getScheme } from '@/common/js/utils'
export default {
  props: {
    country: {
      type: String,
      default: 'MX'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    leaveImmediate () {
      location.href = `${getScheme()}://soda/homePage?closeSideMenu=0`
    }
  }
}
</script>
<style scoped lang="stylus">
.recommend_alert_dialog {
  .layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.50);
    z-index: 100;
  }
  .dialog {
    position: absolute;
    top: 136px;
    left: 95px;
    z-index: 100;
    .background_container {
      margin-top: -305px;
      width: 560px;
      height: 588px;
      background: #FFFFFF;
      border-radius: 12px;
    }
    img {
      width: 560px;
      height: 560px;
    }
    .title {
      margin-top: -283px;
      width: 536px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      padding: 0 17px 0 17px;
      .main {
        margin-top: 10px;
        height: 50px;
        font-family: PingFangSC-Medium;
        font-size: 36px;
        color: #000000;
        text-align: center;
        font-weight: 500;
      }
      .sub {
        height: 80px;
        line-height: 40px;
        margin-top: 14px;
        font-family: PingFangSC-Light;
        font-size: 28px;
        color: #000000;
        font-weight: 200;
      }
    }
    .footer_buttons {
      margin-top: 126px;
      height: 96px;
      display: flex;
      border-top: 1px solid rgba(0,0,0,0.10);
      .button {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC-Medium;
        font-size: 32px;
        color: #666666;
        font-weight: 200;
        &:focus {
          color: #FF7A45;
        }
      }
      .back {
        width: 280px;
        border-right: 1px solid rgba(0,0,0,0.10);
      }
      .stay {
        width: 280px;
      }
    }
  }
}
</style>